import React from "react";
import { Image, Text, Tooltip, VStack } from "@chakra-ui/react";
import styles from "../../../pages/ai-tutor/Doubt/doubt.module.css";
import { isEmptyOrNull } from "../../../utils/common-utils";
import EmptyThumbnail from '../../../assets/ai-tutor/emptyThumb.svg';

export default function ConversationMedia({ mediaDetails, handleShowMedia }) {
  return (
    <React.Fragment>
      {mediaDetails?.length > 0 &&
      mediaDetails?.map((item, index) => {
        let thumbnail = item?.thumbnail_url || item?.videoThumbnail;
        if (item?.media_type?.toLowerCase() == "image") {
          thumbnail = item?.image_url;
        } else if (item?.type?.toLowerCase() == "image") {
          thumbnail = item?.content;
        }
        return (
          <VStack
            onClick={() => {handleShowMedia(item);}}
            mb={2}
            spacing={0}
            key={"index" + index}
            alignItems={"flex-start"}
            boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
            padding={"8px"}
            borderRadius={"8px"}
            border={"1px solid #DFE4E7"}
            bg={"#FFFFFF"}
            _hover={{
              bg: "#F9E2E2"
            }}>

              {item?.title &&
            <Text as={"div"} color="#293238" fontWeight={700} fontSize={"13.34px"} isTruncated mb={1} w={"180px"}>
                  {item?.title}
                </Text>
            }
              <Tooltip label={item?.title}>
                <Image
                className={styles["image"]}
                src={isEmptyOrNull(thumbnail) ? EmptyThumbnail : thumbnail}
                alt={item?.title || ""}
                borderRadius={8}
                border={"0.5px solid #C7C1E5"}
                boxShadow={"sm"} />

              </Tooltip>
            </VStack>);

      })}
    </React.Fragment>);

}